var exports = {
  "k": "x9245d464--a28d32--container",
  "$": "x9245d464--a28d32--notifications",
};

module.exports = exports;
